import React, { useMemo } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

import { getCashFlowData } from './cashFlowProjectionMockData';

interface CashFlowProjectionProps {
  month: string;
}
export const CashFlowProjection = ({
  month = new Date('2024-07-24').getMonth().toString(),
}: CashFlowProjectionProps) => {
  const transformAndFilterData = (rawData: any, month: string) => {
    console.log('dfdsw', month);

    const filteredData = rawData
      .filter((entry: any) => {
        const date = new Date(entry.date);

        return (
          (date.getMonth() + 1).toString() === month &&
          date.getFullYear().toString() ===
            new Date('2024-07-24').getFullYear().toString()
        );
      }) // Filter by month
      .map((entry: any) => {
        // flatten the data
        const transformedEntry: any = { date: entry.date };
        Object.keys(entry.banks).forEach((bank) => {
          ['income', 'expense', 'investment'].forEach((type) => {
            transformedEntry[`${type}_actual`] = entry.banks[bank][type].value;
            transformedEntry[`${type}_projected`] =
              entry.banks[bank][type].projected_value;
          });
        });

        return transformedEntry;
      });

    return filteredData;
  };

  const data = useMemo(
    () => transformAndFilterData(getCashFlowData(), month),
    [month]
  );

  // Define a color scheme for each bank
  // TODO Update this with proper colors
  const colorScheme = {
    income: 'blue',
    expense: 'red',
    investment: 'green',
  };

  // Extract unique keys for actual and projected lines
  const lines = Object.keys(colorScheme).reduce(
    (acc: any, type) => {
      acc.actual.push(`${type}_actual`);
      acc.projected.push(`${type}_projected`);
      return acc;
    },
    { actual: [], projected: [] }
  );

  const CustomLegend = () => {
    return (
      <div style={{ display: 'flex', marginLeft: 70 }}>
        {Object.entries(colorScheme).map(([bank, color], index) => (
          <div key={`item-${index}`} style={{ marginRight: '20px' }}>
            <span
              style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                backgroundColor: color,
                marginRight: '5px',
              }}
            />
            <span>{`${bank.charAt(0).toUpperCase() + bank.slice(1)}`}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div style={{ overflowX: 'scroll', overflowY: 'hidden' }}>
      <div style={{ width: '100%', height: '300px' }}>
        <ResponsiveContainer>
          <LineChart
            data={data}
            margin={{ top: 10, right: 10, bottom: 10, left: -15 }}
          >
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis
              dataKey='date'
              tick={{ fill: 'gray' }}
              tickFormatter={(item) => new Date(item).getDate().toString()}
            />
            <YAxis
              tick={{ fill: 'gray' }}
              tickFormatter={(item) => `${item / 1000}K`}
            />
            <Tooltip />
            <Legend content={<CustomLegend />} />

            {/* Actual Data */}
            {lines.actual.map((dataKey: any) => (
              <Line
                key={dataKey}
                type='monotone'
                dataKey={dataKey}
                stroke={
                  colorScheme[dataKey.split('_')[0] as keyof typeof colorScheme]
                }
                isAnimationActive={false}
                dot={false}
                strokeWidth={2}
                connectNulls={true}
                legendType='line'
                name={`${dataKey.split('_')[0]}`}
              />
            ))}
            {/* Projected Data */}
            {lines.projected.map((dataKey: any) => (
              <Line
                key={dataKey}
                type='monotone'
                dataKey={dataKey}
                stroke={
                  colorScheme[dataKey.split('_')[0] as keyof typeof colorScheme]
                }
                strokeDasharray='5 5'
                isAnimationActive={false}
                dot={false}
                strokeWidth={2}
                connectNulls={true}
                legendType='line'
                name={`${dataKey.split('_')[0]}`}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
